import {Card, CardGroup, CardImg, CardDeck, ListGroup, ListGroupItem, Container, Row, Col} from 'react-bootstrap';

import andre from './images/andre.jpg';
import HomeCSS from'./Home.css';
export default function Home(){
    return ( 
        <Container style={HomeCSS}>
        <Col>
        <ListGroup className="list-group">
            <ListGroup.Item as="h2" style={{color: "#B14AED", border:"none", className: "list-group-item"}}>Hello, my name is Andre Willomitzer!</ListGroup.Item>
            <ListGroup.Item as="h6" style={{border:"none",className: "list-group-item"}}>I am currently enrolled at Seneca College for Computer Programming and Analysis and completing my fifth semester. Focuses of the program include C++ object-oriented programming, web development using HTML/CSS/JavaScript and React/Angular. Furthermore, through this program I have gained experience with SQL, and MongoDB.</ListGroup.Item>
            <ListGroup.Item as="h6" style={{border:"none" , className: "list-group-item"}}>I love listening to music (favourite album is Dark Side of The Moon), gaming, going fishing with my father, and playing with my cat Rosie. In my spare time I enjoy learning about different topics like economics, nature, and programming!</ListGroup.Item>
            <Card style={{marginTop:'20px', marginLeft:"15px",width:"60%", border: "none" , className: "list-group-item"}}>
            
            <Card.Img src={andre}/>
                
            
            </Card>
            <ListGroup.Item as="h4" style={{color: "#B14AED", border:"none"}}>As a developer I am currently looking for a second internship following my first work term to gain even more experience and learn from experienced professionals.</ListGroup.Item>
            <ListGroup.Item as="h4" style={{color: "#B14AED", border:"none"}}>I am a collaborative, ethusiastic individual looking for challenges and opportunities for growth!</ListGroup.Item>
        </ListGroup>
        </Col>
        </Container>
    );
}